var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2235 3.09091H13.3394V0.772727C13.3394 0.567787 13.2575 0.371241 13.1118 0.226327C12.9662 0.0814121 12.7686 0 12.5625 0H6.34794C6.14191 0 5.94432 0.0814121 5.79864 0.226327C5.65296 0.371241 5.57111 0.567787 5.57111 0.772727V3.09091H1.68698C1.48096 3.09091 1.28337 3.17232 1.13768 3.31724C0.992 3.46215 0.910156 3.6587 0.910156 3.86364C0.910156 4.06858 0.992 4.26512 1.13768 4.41004C1.28337 4.55495 1.48096 4.63636 1.68698 4.63636H2.5547L4.02368 16.3231C4.04715 16.5099 4.13841 16.6818 4.28031 16.8065C4.42221 16.9311 4.60498 16.9999 4.79429 17H14.1162C14.3055 16.9999 14.4883 16.9311 14.6302 16.8065C14.7721 16.6818 14.8633 16.5099 14.8868 16.3231L16.3558 4.63636H17.2235C17.4295 4.63636 17.6271 4.55495 17.7728 4.41004C17.9185 4.26512 18.0003 4.06858 18.0003 3.86364C18.0003 3.6587 17.9185 3.46215 17.7728 3.31724C17.6271 3.17232 17.4295 3.09091 17.2235 3.09091ZM7.12476 1.54545H11.7857V3.09091H7.12476V1.54545ZM13.4303 15.4545H5.48022L4.12078 4.63636H14.7897L13.4303 15.4545Z",
    fill: "#BABABA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.266efbd77391ba91a75d047d77010c6a.svg";
export { ForwardRef as ReactComponent };